export enum Permissions {
	// Dashboard
	DashboardView = 'dashboard',
	DashboardOnDemandComputeCostView = 'dashboard__on-demand',
	DashboardEffectiveComputeCostView = 'dashboard__effective',
	DashboardSavingsView = 'dashboard__savings',
	DashboardCoverageView = 'dashboard__coverage',
	DashboardSavingsPlanPurchaseBtn = 'dashboard__savings-plan-purchase-btn',
	DashboardCoverageTypeAndRatioBreakdownWidgetsView = 'dashboard__coverage-type-and-ratio-breakdown-widgets',
	DashboardCoverageRatioSnapshotWidgetView = 'dashboard__coverage-ratio-snapshot-widget',
	DashboardSavingsBreakdownByPlanWidgetView = 'dashboard__savings-breakdown-by-plan-widget',
	DashboardDailyComputeCostView = 'dashboard__daily-compute-cost',
	DashboardPlatformsAndSavingsBreakdownsView = 'dashboard__breakdowns',
	DashboardUncoveredAllAndEffectiveAllView = 'dashboard__uncovered-on-demand-all',
	DashboardLinuxUncoveredODView = 'dashboard__linux-uncovered-od',
	DashboardUncoveredRateAndSavingsPlanUtilizationView = 'dashboard__uncovered-on-demand',
	DashboardFargateView = 'dashboard__fargate',
	DashboardPotentialSavingsDescriptionView = 'dashboard__potential-desc',
	// Savings Plan
	SavingsPlanListView = 'savings-plan__list',
	// EC2
	EC2View = 'ec2',
	EC2KPIsView = 'ec2__kpis',
	EC2FlexibilityWidgetView = 'ec2__flexibility-widget',
	EC2MainTableCoverageKPIsView = 'ec2__coverage-kpi',
	EC2MainTableCoverageKPIsRunningInstancesView = 'ec2__coverage-kpi__running',
	EC2MainTableCoverageKPIsOnDemandInstancesView = 'ec2__coverage-kpi__on-demand',
	EC2MainTableCoverageKPIsSpotInstancesView = 'ec2__coverage-kpi__spot',
	EC2MainTableCoverageKPIsLiveCoverageView = 'ec2__coverage-kpi__live',
	EC2MainTableView = 'ec2__table',
	EC2MainTableCoverageColumnView = 'ec2__table__column-coverage',
	EC2MainTableCoverageColumnProgressBarView = 'ec2__table__column-coverage__progress-bar',
	EC2MainTableAverageRIDurationColumnView = 'ec2__table__column-avgRIDuration',
	EC2MainTableRiSharingColumnView = 'ec2__table__column-riSharing',
	EC2MainTableInstancesMonthlySavingColumnView = 'ec2__table__column-instancesMonthlySavings',
	EC2MainTableAutomationStatusColumnView = 'ec2__table__column-automationStatus',
	EC2MainTableAnnotationPotentialView = 'ec2__table__annotation-potential',
	EC2ResourceInfoPurchaseRIButton = 'ec2__table__item__purchaseRIButton',
	EC2ResourceInfoReservationsTabsView = 'ec2__table__item__ri-tabs',
	EC2ResourceInfoReservedInstancesTabMarketView = 'ec2__table__item__ri-tabs__marketplace',
	EC2ResourceInfoLockedIconView = 'ec2__table__item__ri-tabs__lock-icon',
	EC2ResourceInfoReservedInstancesTabDaysColumnView = 'ec2__table__item__ri-tab__days-column',
	EC2ResourceInfoReservedInstancesActionsColumnView = 'ec2__table__item__ri-tab__actions-column',
	EC2ResourceInfoReservedInstancesIsManagedColumnView = 'ec2__table__item__ri-tab__is-managed-column',
	EC2ResourceInfoRiskAnalysisTabView = 'ec2__table__item__risk-analysis-tab',
	EC2ResourceInfoRIMarketTabView = 'ec2__table__item__ri-market-tab',
	EC2ResourceInfoRIMarketTabOSButtonsView = 'ec2__table__item__ri-market-tab__button',
	EC2ResourceInfoRIMarketTabPurchase = 'ec2__table__item__ri-market-purchase-button',
	EC2LongTimeRIModalView = 'ec2__table__item__modal-long-time-ri-tab', // unused?
	EC2LongTimeRIModal3YearsView = 'ec2__table__item__modal-long-time-ri-tab__3-years', // unused?
	EC2ResourceListRPColumnView = 'ec2__resources__table__column__rp',
	// Admin Panel
	AdminPanelView = 'admin-panel',
	AdminPanelOrganizationsView = 'admin-panel__organizations',
	AdminPanelAccountsView = 'admin-panel__accounts',
	AdminPanelUsersView = 'admin-panel__users',
	AdminPanelReportsView = 'admin-panel__reports',
	AdminPanelApproveBillingView = 'admin-panel__approveBilling',
	AdminPanelPermissionsView = 'admin-panel__permissions',
	AdminPanelPartnersView = 'admin-panel__partners',
	// Partner Portal
	PartnerPortalView = 'partner-portal',
	PartnerPortalOrganizationsView = 'partner-portal__organizations',
	PartnerPortalOrganizationsCreate = 'partner-portal__organizations__create',
	PartnerPortalOrganizationsTableView = 'partner-portal__organizations__table',
	PartnerPortalOrganizationsTableActionsView = 'partner-portal__organizations__actions',
	PartnerPortalOrganizationsTableActionsViewAccountsView = 'partner-portal__organizations__actions__view-accounts',
	PartnerPortalOrganizationsTableActionsSelectOUView = 'partner-portal__organizations__actions__select-ou',
	PartnerPortalAccountsView = 'partner-portal__accounts',
	PartnerPortalAccountsAccountsTabView = 'partner-portal__accounts__accounts-tab',
	PartnerPortalAccountsAccountsTabGenerateCFNLinksView = 'partner-portal__accounts__generate-cfn',
	PartnerPortalAccountsLinksTabView = 'partner-portal__accounts__links-tab',
	PartnerPortalAccountsLinksTabTableView = 'partner-portal__accounts__links-tab__table',
	PartnerPortalAccountsLinksTabTableActionsView = 'partner-portal__accounts__links-tab__actions',
	PartnerPortalAccountsLinksTabTableActionsFinishOnboardingView = 'partner-portal__accounts__links-tab__actions__finish-onboarding',
	PartnerPortalAccountsLinksTabTableActionsDeleteLinkView = 'partner-portal__accounts__links-tab__actions__delete-link',
	PartnerPortalBillingHistoryView = 'partner-portal__billing-history',
	PartnerPortalPRMView = 'partner-portal__report',
	// Zesty Disk
	ZestyDiskView = 'zesty-disk',
	ZestyDiskManagedFilesystemsView = 'zesty-disk__managed-filesystems',
	ZestyDiskManagedFilesystemsInstallAgentView = 'zesty-disk__managed-filesystems__install-agent',
	ZestyDiskManagedFilesystemsTableRowDetailsView = 'zesty-disk__managed-filesystems__details',
	ZestyDiskManagedFilesystemsTableActionsView = 'zesty-disk__managed-filesystems__actions',
	ZestyDiskManagedFilesystemsTableActionsChangePolicyView = 'zesty-disk__managed-filesystems__actions__change-policy',
	ZestyDiskManagedFilesystemsTableActionsDisableEZswitchView = 'zesty-disk__managed-filesystems__EZswitch',
	ZestyDiskManagedFilesystemsTableDetailsOverviewView = 'zesty-disk__managed-filesystems__details__overview',
	ZestyDiskManagedFilesystemsTableDetailsMetricsView = 'zesty-disk__managed-filesystems__details__metrics',
	ZestyDiskManagedFilesystemsTableDetailsPoliciesView = 'zesty-disk__managed-filesystems__details__policies',
	ZestyDiskAutoScalingGroupView = 'zesty-disk__asg',
	ZestyDiskPoliciesView = 'zesty-disk__policies',
	ZestyDiskPoliciesCreate = 'zesty-disk__policies__create',
	ZestyDiskPoliciesTableRowDetails = 'zesty-disk__policies__details',
	ZestyDiskPoliciesTableActionsView = 'zesty-disk__policies__action',
	ZestyDiskPoliciesTableActionsDelete = 'zesty-disk__policies__action__delete',
	ZestyDiskMigrationTasksView = 'zesty-disk__migration-tasks',
	ZestyDiskKPIsView = 'zesty-disk__kpis-cards',
	ZestyDiskUnmanagedDisksView = 'zesty-disk__unmanaged-disks',
	ZestyDiskUnmanagedDisksTableOSTypeColumnView = 'zesty-disk__unmanaged-disks-_zbs_supported_os', // fix key name
	// My Organization
	MyOrganizationView = 'my-organization',
	MyOrganizationGeneralView = 'my-organization__general',
	MyOrganizationGeneralDetailsView = 'my-organization__general__details', // unused?
	MyOrganizationPotentialSavingsDetailsView = 'my-organization__general__potential',
	MyOrganizationUsersView = 'my-organization__users',
	MyOrganizationUsersTableView = 'my-organization__users__table',
	MyOrganizationUsersInvite = 'my-organization__users__add',
	MyOrganizationUsersTableActionsView = 'my-organization__users__actions',
	MyOrganizationUsersTableActionsEnableAndDisable = 'my-organization__users__actions__disable',
	MyOrganizationAccountsView = 'my-organization__accounts',
	MyOrganizationAccountsTableView = 'my-organization__accounts__table',
	MyOrganizationAccountsAddAccount = 'my-organization__accounts__add-account',
	MyOrganizationAccountsTableActionsView = 'my-organization__accounts__actions',
	MyOrganizationAccountsTableActionsRename = 'my-organization__accounts__rename',
	MyOrganizationAccountsTableActionsUpdatePermissions = 'my-organization__accounts__update-permissions',
	MyOrganizationAccountsTableActionsReconnect = 'my-organization__accounts__reconnect',
	MyOrganizationBudgetView = 'my-organization__budget',
	MyOrganizationReportsView = 'my-organization__reports',
	MyOrganizationPaymentHistoryView = 'my-organization__billing-history',
	MyOrganizationOnboardingView = 'my-organization__on-boarding',
	// Unused Resources
	UnusedResourcesView = 'unused-resources',
	UnusedResourcesKPIsView = 'unused-resources__kpis',
	UnusedResourcesPolicyManagerView = 'unused-resources__policy-manager',
	UnusedResourcesUnusedTabView = 'unused-resources__unused-tab',
	UnusedResourcesUnusedTabTableView = 'unused-resources__unused-tab__table',
	UnusedResourcesUnusedTabTableDetailsView = 'unused-resources__unused-tab__row-details',
	UnusedResourcesUnusedTabActionsView = 'unused-resources__unused-tab__actions',
	UnusedResourcesUnusedTabActionsLockAndUnlockView = 'unused-resources__unused-tab__actions__lock',
	UnusedResourcesArchivedTabView = 'unused-resources__archived-tab',
	UnusedResourcesArchivedTabTableView = 'unused-resources__archived-tab__table',
	// S3 Explorer
	S3ExplorerView = 's3',
	S3ExplorerKPIsView = 's3__kpis',
	S3ExplorerTableView = 's3__table',
	// Notification Management
	NotificationManagementView = 'notification-management',
	// Profile
	ProfileView = 'view-profile',
	// Ri Manager
	RiManagerView = 'ri-manager',
	RiManagerMainApproveButtonView = 'ri-manager__main-approve-btn',
	RiManagerUndoApproveButtonView = 'ri-manager__undo-approve-btn',
	RiManagerUndoDeclineButtonView = 'ri-manager__undo-decline-btn',
	// Listings
	ListingsView = 'listings',
	// RF Visualization
	RfVisualization = 'rfVisualization',
	// Audit logs
	AuditLogsView = 'audit-log',
	// Present Mode
	PresentModeView = 'present-mode',
	// Database Explorer
	DatabaseExplorerView = 'database-explorer',
	DatabaseExplorerListView = 'database-explorer__list',
	DatabaseExplorerListCoverageColumnView = 'database-explorer__list__coverage-column',
	DatabaseExplorerTabsView = 'database-explorer__tabs',
	DatabaseExplorerTabsRiskAnalysisView = 'database-explorer__tabs__risk-analysis',
	DatabaseExplorerResourceModalView = 'database-explorer__resource-modal',
}

export interface IPermissionResponseDTO {
	permissions: { [key in Permissions]: boolean };
	success: boolean;
}
